import * as NavConst from '../components/constants/NavigationConstants';
import * as SweetAlert from '../components/common/utilities/ConfirmationAlert';
import { MODULE, GENERIC_PAGINATED_KEY_VALUE_LIST, getApiPath, DELETE, LIST, GENERIC_PAGINATED } from '../api/ApiConst';

export const Logs = {
  basePath: "log_",
  tableDataUrl:GENERIC_PAGINATED,
  label: "Logs",
  attributes: [{ name: "id", value: "id", type: "text", position: 0, formAttribute: false },
  { name: "request_uri", value: "request_uri", type: "text", position: 1, formAttribute: true, className: "form-control input-default" },
  { name: "request_method", value: "request_method", type: "text", position: 2, formAttribute: true, className: "form-control input-default" },
  { name: "request", value: "request", type: "text", position: 3, formAttribute: true, className: "form-control input-default" },
  { name: "response", value: "response", type: "text", position: 4, formAttribute: true, className: "form-control input-default" },
  { name: "header", value: "header", type: "text", position: 5, formAttribute: true, className: "form-control input-default" },
  
  { name: "status_code", value: "status_code", type: "text", position: 6, formAttribute: true, className: "form-control input-default" },
  { name: "ip", value: "ip", type: "text", i: 4, position :7, formAttribute: true, className: "form-control input-default" },
  { name: "from_user", value: "from_user", type: "text",position :8, i: 4, formAttribute: true, className: "form-control input-default" },
  { name: "lat", value: "lat", type: "text",position :9, i: 4, formAttribute: true, className: "form-control input-default" },
  { name: "long", value: "long", type: "text",position :10, i: 4, formAttribute: true, className: "form-control input-default" }
  ],
  actions: [
    { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
    {
      name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
      navigatePath: getApiPath(MODULE, DELETE), replaceData: "{recordId}"
    },
    { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
    { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
  ]
};



